module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "prominent": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  }), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.cxt.getTitle()))]) : _vm._e()], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isFilterMode()),
      expression: "!cxt.isFilterMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs8": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    },
    model: {
      value: (_vm.cxt.filterString),
      callback: function($$v) {
        _vm.$set(_vm.cxt, "filterString", $$v)
      },
      expression: "cxt.filterString"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isSelectMode()),
      expression: "!cxt.isSelectMode()"
    }]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isFilterMode()),
      expression: "!cxt.isFilterMode()"
    }]
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.openDeed(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)]), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxt,
      "flat": ""
    }
  })], 1), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "height": "2",
      "active": _vm.getItemSet.isProcessing(),
      "indeterminate": true
    }
  }), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll",
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: item.id,
      attrs: {
        "value": _vm.cxt.activated(item.id),
        "active-class": "v-dealger-favorite-active v-list__tile--highlighted "
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          !_vm.cxt.isSelectMode() ? _vm.openItem(item) : _vm.cxt.select(item.id)
        }
      }
    }, [_c('v-list-tile-content', {
      staticStyle: {
        "justify-content": "start"
      }
    }, [_c('v-list-tile-title', [_c('b', [_c('a', {
      attrs: {
        "href": _vm.getItemRef(item)
      }
    }, [_vm._v(_vm._s(item.title))])])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n               " + _vm._s(item.description) + "\n                ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.cxt.isSelectMode()),
        expression: "!cxt.isSelectMode()"
      }]
    }, [_vm._v(" " + _vm._s(_vm.formatState(item.state)) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.isSelectMode()),
        expression: "cxt.isSelectMode()"
      }]
    }, [_c('v-list-tile-action-text', [_vm._v("  " + _vm._s(_vm.formatState(item.state)) + " ")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(item.id)),
        expression: "cxt.check(item.id)"
      }]
    }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(item.id)),
        expression: "cxt.uncheck(item.id)"
      }]
    }, [_vm._v("check_box_outline_blank")])], 1)], 1)], 1)]
  })], 2), _vm._v(" "), _c('v-panel-title', {
    attrs: {
      "value": false,
      "caption": 'Еще',
      "expandable": _vm.filteredItems.length < _vm.getItemSet.getTotal()
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ea6022b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/PeopleSet.vue
// module id = 1123
// module chunks = 1